import React, { useEffect, useState } from 'react';
import { useAuthContext } from '../../context/AuthContext';
import { NavLink, useLocation, useNavigate, Outlet } from 'react-router-dom';
import LogoutButton from '../../Components/LogoutButton';
import Spinner from '../../Components/Spinner';

const linksTo = [
  { link: '/dashboardAdx/stats', title: 'Главная' },
  { link: '/dashboardAdx/search', title: 'Users' },
  //{ link: '/dashboardAdx/#', title: 'Поддержка' },
    //{ link: '/dashboardAdx/central', title: 'Настройки' },
];

const themes = {
  light: 'theme-light',
};

const Dashboard = () => {
  const { user, loading } = useAuthContext();
  const navigate = useNavigate();
  const [theme, setTheme] = useState('light');
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('admin-theme') || 'light';
    setTheme(saved);
    document.documentElement.className = themes[saved];
  }, []);

  const changeTheme = (value) => {
    setTheme(value);
    document.documentElement.className = themes[value];
    localStorage.setItem('admin-theme', value);
  };

  const location = useLocation();
  useEffect(() => {
    if (!loading && !user) navigate('/dashboardlogin');
  }, [user, loading]);

  if (loading) return <Spinner />;
  if (!user) return null;

  return (
    <div className="min-h-screen text-base transition-all duration-300">
      <nav className="fixed top-0 left-0 right-0 shadow z-50 px-6 py-3 bg-nav flex items-center justify-between">
        {/* Левая часть: логотип и email */}
        <div className="flex items-center gap-4">
          <img src="/loader.svg" alt="logo" className="w-6 h-6" />
          <span className="font-semibold">{user.email}</span>
        </div>

        {/* Кнопка бургер */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden focus:outline-none"
        >
          <svg
            className="w-6 h-6 text-text"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
            />
          </svg>
        </button>

        {/* Меню десктоп */}
        <div className="hidden md:flex items-center gap-3">
          {linksTo.map((item) => (
            <NavLink
              key={item.link}
              to={item.link}
              className={({ isActive }) =>
                `px-4 py-2 rounded-md font-medium ${
                  isActive ? 'bg-accent text-black' : 'hover:bg-hover text-text'
                }`
              }
            >
              {item.title}
            </NavLink>
          ))}
         {/* <ThemeSwitcher selectedTheme={theme} onChange={changeTheme} />*/}
          <LogoutButton />
        </div>
      </nav>

      {/* Мобильное меню */}
      {isOpen && (
        <div className="md:hidden bg-nav px-6 pb-4 shadow z-40 mt-[52px]">
          <div className="flex flex-col gap-2">
            {linksTo.map((item) => (
              <NavLink
                key={item.link}
                to={item.link}
                onClick={() => setIsOpen(false)}
                className={({ isActive }) =>
                  `block px-4 py-2 rounded-md font-medium ${
                    isActive ? 'bg-accent text-white' : 'hover:bg-hover text-text'
                  }`
                }
              >
                {item.title}
              </NavLink>
            ))}
           {/* <ThemeSwitcher selectedTheme={theme} onChange={changeTheme} />*/}
            <LogoutButton />
          </div>
        </div>
      )}
      <main className="pt-[64px] px-6 bg-bg min-h-screen transition-colors duration-300">
        <Outlet />

      </main>
    </div>
  );
};

export default Dashboard;
